/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const RegisterConfirmationPage = lazyLoad(
  () => import('./index'),
  module => module.RegisterConfirmation,
);
